module.exports = __webpack_public_path__ + "img/facial-skin-age.f71ee8d1.svg";